import React from "react"
import { parseQuery } from "../models/FilterState"

interface Props {
  showCustom: boolean
}

export default function FilterTabs({ showCustom }: Props) {
  let parsed = parseQuery(window.location.search)

  return (
    <nav className="tabs-component sm:col-span-3" data-role="tenant-tabs">
      <div className="navheader">Filters:</div>
      <a href={window.location.pathname} className={tabClasses(!parsed.custom && !parsed.advanced)}>
        <span>Basic Filters</span>
      </a>
      <a
        href={`${window.location.pathname}?advanced=true`}
        className={tabClasses(parsed.advanced)}
        data-role="advanced-filters"
      >
        <span>Advanced Filters</span>
      </a>
      {showCustom && (
        <a
          href={`${window.location.pathname}?custom=true`}
          className={tabClasses(parsed.custom)}
          data-role="individual-recipients"
        >
          <span>Individual Recipients</span>
        </a>
      )}
    </nav>
  )
}

function tabClasses(condition) {
  if (condition) {
    return "tabs--active-tab"
  } else {
    return "tabs--inactive-tab"
  }
}
